'use client';

import Link from 'next/link';
import { useState } from 'react';
// import { setPage } from '@channel.io/channel-web-sdk-loader'
import { EffectCoverflow, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import useSWR from 'swr';
import { z } from 'zod';

import Img from '@/legacy/components/img/FillImage';

import { nullBannerReplace } from '@/utilities/stateTool';

import 'swiper/css/effect-coverflow';

import { stepinContentInstance } from '@/apis/types/stepinContent';
import styles from '@/legacy/components/new/tournamentBanner.module.scss';
import 'swiper/css';

const { GET } = stepinContentInstance;

const getBanner = async () => {
	const { data, error } = await GET('/v2/tournament/banner/list');

	if (data) return data.data?.banners;

	if (error) throw error;
};

const urlSchema = z.string().url();

const Page = ({ src, url }: { src: string; url?: string }) => {
	const isUrl = urlSchema.safeParse(url).success;
	const completeURL = url == null ? '#' : isUrl ? url : 'https://' + url;

	return (
		<Link className={styles.posterFrame} href={completeURL} referrerPolicy="no-referrer" scroll={false} target="_blank">
			<Img
				className={styles.poster}
				onError={(e) => {
					e.currentTarget.src = nullBannerReplace(null);
					e.currentTarget.alt = 'placeholder image';
				}}
				src={nullBannerReplace(src)}
			/>

			{/* <div className={styles.before}></div>
			<div className={styles.after}></div> */}
		</Link>
	);

	// 사진에 그라디언트 맞춘
	// return (
	// 	<div className={styles.posterFrame} style={{ background: '#1a1a20' }}>
	// 		{active && (
	// 			<div className={styles.active}>
	// 				<img
	// 					src={nullBannerReplace(src)}
	// 					style={{ objectFit: 'cover' }}
	// 					className={styles.poster}
	// 					onError={(e) => {
	// 						e.currentTarget.src = nullBannerReplace(null)
	// 						e.currentTarget.alt = 'placeholder image'
	// 					}}
	// 				/>

	// 				<div className={styles.before}></div>
	// 				<div className={styles.after}></div>
	// 			</div>
	// 		)}
	// 	</div>
	// )

	// 백그라운드 블러 적용하고
	// return (
	// 	<div className={styles.posterFrame}>
	// 		<Img
	// 			src={nullBannerReplace(src)}
	// 			className={styles.poster}
	// 			onError={(e) => {
	// 				e.currentTarget.src = nullBannerReplace(null)
	// 				e.currentTarget.alt = 'placeholder image'
	// 			}}
	// 			style={{ filter: active ? 'blur(10px)' : 'none' }}
	// 		></Img>
	// 		{active && (
	// 			// next image 는 가변 제어되는 position 을 지원 안함
	// 			// 적당히 cover 하는 걸 말하는 것 같은데.. 음
	// 			// 80% 기준으로 만든 다음에 1.25 배 하면 되긴 함

	// 			<div className={styles.active}>
	// 				<img
	// 					src={nullBannerReplace(src)}
	// 					style={{ objectFit: 'cover' }}
	// 					className={styles.poster}
	// 					onError={(e) => {
	// 						e.currentTarget.src = nullBannerReplace(null)
	// 						e.currentTarget.alt = 'placeholder image'
	// 					}}
	// 				/>
	// 				<Img
	// 					src={nullBannerReplace(src)}
	// 					className={styles.poster}
	// 					style={{ objectFit: 'contain' }}
	// 					onError={(e) => {
	// 						e.currentTarget.src = nullBannerReplace(null)
	// 						e.currentTarget.alt = 'placeholder image'
	// 					}}
	// 				></Img>
	// 				{/* <div className={styles.before}></div>
	// 				<div className={styles.after}></div> */}
	// 			</div>
	// 		)}
	// 	</div>
	// )
};

const TournamentBanner = () => {
	const { data } = useSWR('getBanner', () => getBanner());
	const [active, setActive] = useState(1);

	// 빈 상태 처리
	if (data && data.length > 0) {
		return (
			<>
				<Swiper
					breakpoints={{
						784: {
							coverflowEffect: {
								stretch: 550,
							},
							pagination: {
								clickable: true,
								enabled: false,
							},
						},
					}}
					centeredSlides={true}
					className={styles.rowWrap}
					coverflowEffect={{
						depth: 0,

						modifier: 1,
						rotate: 0,
						scale: 0.8,
						slideShadows: true,
						stretch: 0,
					}}
					// pagination={true}
					effect={'coverflow'}
					// spaceBetween={-340}
					grabCursor={true}
					initialSlide={active}
					modules={[EffectCoverflow, Pagination]}
					onSlideChange={(e) => setActive(e.activeIndex)}
					pagination={{
						clickable: true,
						enabled: true,
					}}
					slidesPerView={'auto'}
				>
					{data.map((item, index) => {
						return (
							<SwiperSlide key={item.bannerImageUrl + index}>
								{/* <Page src={src} active={index === active} /> */}
								<Page src={item.bannerImageUrl} url={item.bannerUrl} />
							</SwiperSlide>
						);
					})}
				</Swiper>
			</>
		);
	}

	return <></>;
};

export default TournamentBanner;
